export default "__VITE_ASSET__8334f2bf__"